module.exports = __webpack_public_path__ + "static/media/img_g1.5542f6c6.webp";